"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.SquareView = function (_a) {
    var _b;
    var board = _a.board, lightSquare = _a.lightSquare, position = _a.position, children = _a.children, dropTarget = _a.dropTarget, _c = _a.style, style = _c === void 0 ? {} : _c, className = _a.className, isOver = _a.isOver, canDrop = _a.canDrop, props = __rest(_a, ["board", "lightSquare", "position", "children", "dropTarget", "style", "className", "isOver", "canDrop"]);
    var piece = board.get(position);
    return (react_1.default.createElement("div", __assign({ id: position.toCoordinate(), ref: dropTarget ? dropTarget : null, style: __assign({ background: lightSquare ? board.boardTheme.lightSquare : board.boardTheme.darkSquare }, style), className: classnames_1.default((_b = {
                "chess-board-square": true,
                "chess-board-square--light": lightSquare,
                "chess-board-square--dark": !lightSquare
            },
            _b[piece] = piece,
            _b), className) }, props), children));
};
exports.default = exports.SquareView;
